import {Component, Input, OnInit} from '@angular/core';
import {RatingsPageService} from "../../services/ratings-page.service";

@Component({
  selector: 'app-ratings-page',
  templateUrl: './ratings-page.component.html',
  styleUrls: ['./ratings-page.component.scss']
})
export class RatingsPageComponent implements OnInit {

  @Input() isStaff;

  constructor(
    private ratingsPageService: RatingsPageService
  ) { }

  ngOnInit(): void {
    console.debug('this is isStaff', this.isStaff);
    this.isStaff = this.isStaff === 'True';
    this.ratingsPageService.isStaff = this.isStaff;
  }

}
